import generateProfile from "./generateProfile";

function getProfile(user) {
    return user.picture || generateProfile(user.username);
}

export default getProfile;
